<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
 <div class="user-profile" [style.background-image]="'url(' + (backgroundImageBase64 || 'assets/images/background/user-info.jpg') + ')'" style="background-repeat: no-repeat;">
    <!-- User profile image -->
    <div class="profile-img"> <ng-container *ngIf="picture ==null || picture ==''"><img [src]="profileImageBase64 || 'assets/images/profile.jpg'" alt="user" class="profile-pic" matBadge="8" matBadgePosition="after" matBadgeColor="warn"></ng-container>
      <ng-container *ngIf="picture !=null && picture !=''"><img [src]="picture" alt="user" width="110px" height="50px"class="profile-pic"></ng-container> </div>
    <!-- User profile text-->
    <!-- ============================================================== -->
    <!-- Profile - style you can find in header.scss -->
    <!-- ============================================================== -->
    <div class="profile-text"><a [matMenuTriggerFor]="sdprofile" class=""> {{userinfo?.nom}} {{userinfo?.prenom}} <i class="ti-angle-down font-12 m-l-5"></i></a></div>
    <mat-menu #sdprofile="matMenu" class="mymegamenu">
        <!-- <button mat-menu-item>
            <mat-icon>settings</mat-icon>
          Settings 
        </button> -->

        <button (click)="viewProfil()" mat-menu-item>
            <mat-icon>account_box</mat-icon>
            Profile
         </button>

        <!-- <button mat-menu-item>
            <mat-icon>notifications_off</mat-icon> Disable notifications </button> -->

        <button mat-menu-item (click)="logout()">
            <mat-icon>exit_to_app</mat-icon>
            {{'logout' | translate }} 
        </button>
        
        <button mat-menu-item (click)="closesession()">
          <mat-icon>logout</mat-icon> 
          {{'closesession' | translate}} 
        </button>
    </mat-menu>

</div>
<mat-nav-list appAccordion>
    <ng-container *ngIf="section =='admin'">
      <mat-list-item appAccordionLink *ngFor="let menuitem of menuItems.getMenuitem()" routerLinkActive="selected" group="{{menuitem.state}}">
        <ng-container *ngFor="let  item of userprivileges">
          <!-- {{item.privileges.codepriv}} -->
          <ng-container *ngIf="item.privileges.codepriv == menuitem.priv && item.state">
            <a class="" appAccordionToggle [routerLink]="['/'+menuitem.state]" *ngIf="menuitem.type === 'link'">
              <mat-icon>{{ menuitem.icon }}</mat-icon>
              <span>{{ menuitem.name | translate }}</span>
              <span fxFlex></span>
              <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
          </a>
          </ng-container>

        </ng-container>

        <!-- <ng-container>

            <a appAccordionToggle class="relative" [id]="menuitem.state" href="javascript:;"
            *ngIf="menuitem.type === 'sub'">
            <mat-icon *ngIf="menuitem.iconType==='icon'" class="material-icons-round">{{ menuitem.icon }}
            </mat-icon>
            <mat-icon *ngIf="menuitem.iconType==='svg'"><svg class="svg-24" viewBox="0 0 24 24">
                    <path fill="currentColor" [attr.d]="menuitem.icon" /></svg></mat-icon>
            <span>{{ menuitem.name}}</span>
            <span fxFlex></span>
            <span class="menu-badge mat-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
            <mat-icon class="menu-caret">arrow_drop_down</mat-icon>
          </a>
          <mat-nav-list class="sub-menu" *ngIf="menuitem.type === 'sub'">
            <mat-list-item *ngFor="let childitem of menuitem.children" routerLinkActive="open">
                <a [routerLink]="['/', childitem.state ]" class="relative">
                    <mat-icon *ngIf="childitem.iconType==='icon'" class="material-icons-round">
                        {{ childitem.icon }}</mat-icon>
                    <mat-icon *ngIf="childitem.iconType==='svg'"><svg class="svg-24" viewBox="0 0 24 24">
                            <path fill="currentColor" [attr.d]="childitem.icon" /></svg></mat-icon>
                    <span>{{ childitem.name }}</span>
                </a>
            </mat-list-item>
          </mat-nav-list>
        </ng-container> -->


    </mat-list-item>
    </ng-container>
    <ng-container *ngIf="section =='guichet'">
      <mat-list-item appAccordionLink *ngFor="let menuitem of menuItems2.getMenuitem()" routerLinkActive="selected" group="{{menuitem.state}}">
        <ng-container *ngFor="let  item of userprivileges">
          <!-- {{item.privileges.codepriv}} -->
          <ng-container *ngIf="item?.privileges.codepriv == menuitem.priv && item.state">
            <a class="" appAccordionToggle [routerLink]="['/'+menuitem.state]" *ngIf="menuitem.type === 'link'">
              <mat-icon>{{ menuitem.icon }}</mat-icon>
              <span>{{ menuitem.name | translate }}</span>
              <span fxFlex></span>
              <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
          </a>
          </ng-container>

        </ng-container>
      </mat-list-item>
    </ng-container>

        <ng-container *ngIf="section =='chef'">
          <mat-list-item appAccordionLink *ngFor="let menuitem of menuItems4.getMenuitem()" routerLinkActive="selected" group="{{menuitem.state}}">
            <ng-container *ngFor="let  item of userprivileges">
              <!-- {{item.privileges.codepriv}} -->
              <ng-container *ngIf="item?.privileges.codepriv == menuitem.priv && item.state">
                <a class="" appAccordionToggle [routerLink]="['/'+menuitem.state]" *ngIf="menuitem.type === 'link'">
                  <mat-icon>{{ menuitem.icon }}</mat-icon>
                  <span>{{ menuitem.name | translate }}</span>
                  <span fxFlex></span>
                  <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
              </a>
              </ng-container>

            </ng-container>
          </mat-list-item>
        </ng-container>

            <ng-container *ngIf="section =='envoi'">
              <mat-list-item appAccordionLink *ngFor="let menuitem of menuItems3.getMenuitem()" routerLinkActive="selected" group="{{menuitem.state}}">
                <ng-container *ngFor="let  item of userprivileges">
                  <!-- {{item.privileges.codepriv}} -->
                  <ng-container *ngIf="item?.privileges.codepriv == menuitem.priv && item.state">
                    <a class="" appAccordionToggle [routerLink]="['/'+menuitem.state]" *ngIf="menuitem.type === 'link'">
                      <mat-icon>{{ menuitem.icon }}</mat-icon>
                      <span>{{ menuitem.name | translate }}</span>
                      <span fxFlex></span>
                      <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
                  </a>
                  </ng-container>

                </ng-container>
              </mat-list-item>
            </ng-container>

                <ng-container *ngIf="section =='retrait'">
                  <mat-list-item appAccordionLink *ngFor="let menuitem of menuItems5.getMenuitem()" routerLinkActive="selected" group="{{menuitem.state}}">
                    <ng-container *ngFor="let  item of userprivileges">
                      <!-- {{item.privileges.codepriv}} -->
                      <ng-container *ngIf="item?.privileges.codepriv == menuitem.priv && item.state">
                        <a class="" appAccordionToggle [routerLink]="['/'+menuitem.state]" *ngIf="menuitem.type === 'link'">
                          <mat-icon>{{ menuitem.icon }}</mat-icon>
                          <span>{{ menuitem.name | translate }}</span>
                          <span fxFlex></span>
                          <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
                      </a>
                      </ng-container>

                    </ng-container>
        <!-- <ng-container>

            <a appAccordionToggle class="relative" [id]="menuitem.state" href="javascript:;"
            *ngIf="menuitem.type === 'sub'">
            <mat-icon *ngIf="menuitem.iconType==='icon'" class="material-icons-round">{{ menuitem.icon }}
            </mat-icon>
            <mat-icon *ngIf="menuitem.iconType==='svg'"><svg class="svg-24" viewBox="0 0 24 24">
                    <path fill="currentColor" [attr.d]="menuitem.icon" /></svg></mat-icon>
            <span>{{ menuitem.name}}</span>
            <span fxFlex></span>
            <span class="menu-badge mat-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
            <mat-icon class="menu-caret">arrow_drop_down</mat-icon>
          </a>
          <mat-nav-list class="sub-menu" *ngIf="menuitem.type === 'sub'">
            <mat-list-item *ngFor="let childitem of menuitem.children" routerLinkActive="open">
                <a [routerLink]="['/', childitem.state ]" class="relative">
                    <mat-icon *ngIf="childitem.iconType==='icon'" class="material-icons-round">
                        {{ childitem.icon }}</mat-icon>
                    <mat-icon *ngIf="childitem.iconType==='svg'"><svg class="svg-24" viewBox="0 0 24 24">
                            <path fill="currentColor" [attr.d]="childitem.icon" /></svg></mat-icon>
                    <span>{{ childitem.name }}</span>
                </a>
            </mat-list-item>
          </mat-nav-list>
        </ng-container> -->


    </mat-list-item>
    </ng-container>


</mat-nav-list>
